'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'sun-bright';
var width = 512;
var height = 512;
var aliases = ["sun-alt"];
var unicode = 'e28f';
var svgPathData = 'M232 488l0-80 48 0 0 104-48 0 0-24zm0-408l0-80 48 0 0 104-48 0 0-24zM92 58c7.5 7.5 26.4 26.4 56.6 56.6l17 17-33.9 33.9C124 158 105.1 139.1 75 108.9L58 92 92 58zM380.5 346.5l73.5 73.5-33.9 33.9-73.5-73.5 33.9-33.9zM0 232l104 0 0 48-104 0 0-48zm408 0l104 0 0 48-104 0 0-48zM58 420c7.5-7.5 26.4-26.4 56.6-56.6l17-17 33.9 33.9c-7.5 7.5-26.4 26.4-56.6 56.6L92 454 58 420zM346.5 131.5c7.5-7.5 26.4-26.4 56.6-56.6L420 58 454 91.9c-7.5 7.5-26.4 26.4-56.6 56.6l-17 17-33.9-33.9zM320 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-176 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSunBright = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;